import { useAppStore } from '@/stores/AppStore'
import type { MembercardWebapp } from '@/type/MemberCard'
import { showNotify } from 'vant/es/notify/function-call'
import { closeToast, showLoadingToast } from 'vant/es/toast/function-call'

export interface MemberCardSpendingSummary {
  totalSpending: number
  totalSpendingLeft: number
  nextLevelMinSpending: number
}

export const getMemberCardSpendingSummary = (memberCard?: MembercardWebapp | null): MemberCardSpendingSummary => {
  if (!memberCard) {
    return {
      totalSpending: 0,
      totalSpendingLeft: 0,
      nextLevelMinSpending: 0,
    }
  }

  // case max level, จะคำนวณโดยใช้ min_spending ของ level เดิม เพื่อเอามาต่ออายุ
  if (memberCard.is_max) {
    const minSpending = Number(memberCard.member_card.min_spending) || 0
    if (!minSpending) {
      return {
        totalSpending: 0,
        totalSpendingLeft: 0,
        nextLevelMinSpending: 0,
      }
    }

    const totalSpending = (Number(memberCard.total_spending) || 0) % minSpending
    return {
      totalSpending,
      totalSpendingLeft: minSpending - totalSpending,
      nextLevelMinSpending: minSpending,
    }
  }

  // case normal level, backend ส่งมาให้หมดแล้ว
  return {
    totalSpending: Number(memberCard.total_spending) || 0,
    totalSpendingLeft: Number(memberCard.total_spending_left) || 0,
    nextLevelMinSpending: Number(memberCard.next_level_min_spending) || 0,
  }
}

// TODO: ย้าย member card จาก AppStore มาเป็น MemberCardStore แยกต่างหาก
export const usePatientMemberCard = () => {
  const appStore = useAppStore()

  // Fetch member card data
  const fetchMemberCard = async (patient_uuid: string) => {
    // Check if member card already exists in store
    if (appStore.memberCard) return appStore.memberCard

    // Fetch member card using patient uuid
    if (patient_uuid) {
      showLoadingToast({
        message: 'กำลังโหลดข้อมูลสมาชิก...',
        forbidClick: true,
        duration: 0,
      })

      try {
        await appStore.setMemberCard()
        closeToast()
        return appStore.memberCard
      } catch (error) {
        closeToast()
        showNotify({
          type: 'danger',
          message: 'ไม่สามารถโหลดข้อมูลสมาชิกได้ กรุณาลองใหม่อีกครั้ง',
          duration: 5000,
        })
      }
    }
  }

  const getSpendingSummary = (memberCard?: MembercardWebapp | null) => {
    return getMemberCardSpendingSummary(memberCard)
  }

  return {
    fetchMemberCard,
    getSpendingSummary,
  }
}
